<div style="margin: 16px; padding-bottom: 1px;">
  <div style="margin: auto;" [style.width]="authService.isLoggedIn()? '100%': '80%'">
    <div style="padding: 16px; width: 100%; background: #fff; font-size: 14px; font-weight: 500; border-radius: 8px;"
      class="card-item app-shadow">
      <div *ngIf="!vendor">
        <nz-alert nzType="warning" nzMessage="Warning" nzDescription={{getMessage()}} nzShowIcon></nz-alert>

      </div>
      <div *ngIf="vendor">
        <div class="text-center font-18 font-weight-700" style="margin-bottom: 15px;">
          {{vendor}} Api Doc
        </div>
        <!--  Get product list api : Start -->
        <div>
          <div class="font-weight-600 font-16">
            Get product list api
          </div>
          <span class="font-weight-600">
            Method:
          </span>
          <span style="font-style: italic;">GET</span>
          <app-copy-to-clipboard [title]="'URL'" [api]="productsApi"></app-copy-to-clipboard>


        </div>
        <div class="font-italic">
          Success Response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
            <code>
                <span>
                    {{successRes}}
                </span>
            </code>
        </pre>
        </div>
        <div class="font-italic">
          Server error response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
            <code>
                <span>
                    {{wrongServiceRes}}
                </span>
            </code>
        </pre>
        </div>
        <!--  Get product list api : End -->

        <!--   Checkout api(Initiate charging) : Start -->
        <div>
          <div class="font-weight-600 font-16">
            Checkout api(Initiate charging)
          </div>
          <span class="font-weight-600">
            Method:
          </span>
          <span style="font-style: italic;">POST</span>
          <app-copy-to-clipboard [title]="'URL'" [api]="createCheckoutSessionApi"></app-copy-to-clipboard>
        </div>
        <div class="font-italic">
          Reqeust body:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                      <code>
                                          <span>
                                              {{reqBody}}
                                          </span>
                                      </code>
                                  </pre>
        </div>
        <div class="font-italic">
          Success Response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                      <code>
                                          <span>
                                              {{reqSucRes}}
                                          </span>
                                      </code>
                                  </pre>
        </div>
        <div class="font-italic">
          Server error response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                      <code>
                                          <span>
                                              {{reqServerErrorRes}}
                                          </span>
                                      </code>
                                  </pre>
        </div>
        <!--   Checkout api(Initiate charging) : End -->

        <!--    Subscription check api : Start -->
        <div>
          <div class="font-weight-600 font-16">
            Subscription check api
          </div>
          <span class="font-weight-600">
            Method:
          </span>
          <span style="font-style: italic;">GET</span>
          <app-copy-to-clipboard [title]="'URL'" [api]="checkSubscriptionApi"></app-copy-to-clipboard>
        </div>
        <div class="font-italic">
          Success Response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                          <code>
                                              <span>
                                                  {{checkReqRes}}
                                              </span>
                                          </code>
                                      </pre>
        </div>
        <div class="font-italic">
          Not found subscription Response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                          <code>
                                              <span>
                                                  {{checkNotFoundRes}}
                                              </span>
                                          </code>
                                      </pre>
        </div>
        <!--    Subscription check api : End -->

        <!--    Subscription cancel api : End -->
        <div>
          <div class="font-weight-600 font-16">
            Subscription cancel api
          </div>
          <span class="font-weight-600">
            Method:
          </span>
          <span style="font-style: italic;">POST</span>
          <app-copy-to-clipboard [title]="'URL'" [api]="cancelSubscriptionApi"></app-copy-to-clipboard>
          <div>
            <span class="font-weight-600">
              Api key(need to pass in header):
            </span>
            <span style="font-style: italic;">x-api-key</span>
          </div>
          <div>
            <span class="font-weight-600">
              Value:
            </span>
            <span style="font-style: italic;">check it in
              <span class="app-link">cancelApiEncryptionDoc</span>
            </span>
          </div>
        </div>
        <div>
          <div class="font-italic">
            Reqeust body:
          </div>
          <div class="code-block-container">
            <pre class="code-block">
                                              <code>
                                                  <span>
                              "8m9XxNZx0MdaJmTvOyzKD6WWZmvd6t0/cqueBUIOdGXRIv0lbJKOC3AFeRZ/w+0ZZ6TCcFxAd4hFOKVaG/ri3w=="
                                                  </span>
                                              </code>
                                          </pre>
          </div>
          <div class="font-16">
            Note:
          </div> Here Request body is a encrypted string. See more about encryption in
          <span class="app-link">cancelApiEncryptionDoc</span>
        </div>
        <div class="font-italic">
          Success Response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                          <code>
                                              <span>
                                                  {{cancelReq}}
                                              </span>
                                          </code>
                                      </pre>
        </div>
        <div class="font-italic">
          Failed Response:
        </div>
        <div class="code-block-container">
          <pre class="code-block">
                                          <code>
                                              <span>
                                                  {{cancelRes}}
                                              </span>
                                          </code>
                                      </pre>
        </div>
        <!--    Subscription cancel api : End -->
      </div>
    </div>
  </div>
</div>